// Khai báo các bảng AppSheet của module lương và chuyển dòng sheet <-> object.
//
// Mỗi cột: [tên cột trên AppSheet, tên trường trong code, kiểu]. Tên trường đặt theo VUONGDATWOOD_V2
// (MA_BIEN, HIEU_LUC_TU, NHAN_SU_ID...) để code chuyển từ V2 dùng gần như nguyên văn. Mọi giá trị đi
// qua sheetFormat nên ngày, số, Yes/No, JSON đọc ghi cùng một cách ở mọi bảng.
import { equalsSelector, findRows, writeRows } from './appsheet';
import {
    parseSheetBoolean, parseSheetDate, parseSheetJson, parseSheetNumber,
    toSheetDate, toSheetDateTime, toSheetJson,
} from './sheetFormat';

const TEXT = 'text';
const NUMBER = 'number';
const DATE = 'date';
const DATETIME = 'datetime';
const BOOL = 'bool';
const JSON_OBJECT = 'json';
const JSON_LIST = 'list';
// Mảng bản ghi (object), khác JSON_LIST là mảng mã dạng chuỗi: đọc bằng JSON_LIST thì mỗi phần tử
// thành chữ "[object Object]" và lương sản phẩm âm thầm về 0.
const JSON_ROWS = 'rows';

export const PAYROLL_TABLES = {
    variables: {
        table: 'DM_BIEN_CONG_LUONG',
        key: 'MA_BIEN',
        columns: [
            ['MÃ BIẾN', 'MA_BIEN', TEXT],
            ['TÊN BIẾN', 'TEN_BIEN', TEXT],
            ['LOẠI BIẾN', 'LOAI_BIEN', TEXT],
            ['NGUỒN DỮ LIỆU', 'NGUON_DU_LIEU', TEXT],
            ['KIỂU DỮ LIỆU', 'LOAI_DU_LIEU', TEXT],
            ['ĐƠN VỊ', 'DON_VI', TEXT],
            ['CÔNG THỨC', 'CONG_THUC', TEXT],
            ['NHÓM', 'NHOM', TEXT],
            ['THỨ TỰ', 'THU_TU', NUMBER],
            ['HOẠT ĐỘNG', 'HOAT_DONG', BOOL],
            ['MÔ TẢ', 'MO_TA', TEXT],
        ],
    },
    constants: {
        table: 'HANG_SO_BIEN_CONG_LUONG',
        key: 'ID',
        columns: [
            ['ID', 'ID', TEXT],
            ['MÃ BIẾN', 'MA_BIEN', TEXT],
            ['HIỆU LỰC TỪ', 'HIEU_LUC_TU', DATE],
            ['HIỆU LỰC ĐẾN', 'HIEU_LUC_DEN', DATE],
            ['GIÁ TRỊ', 'GIA_TRI', NUMBER],
            ['GHI CHÚ', 'GHI_CHU', TEXT],
            ['NGƯỜI TẠO', 'NGUOI_TAO', TEXT],
            ['NGÀY CẬP NHẬT', 'UPDATED_AT', DATETIME],
        ],
    },
    formulas: {
        table: 'CONG_THUC_BIEN_CONG_LUONG',
        key: 'ID',
        columns: [
            ['ID', 'ID', TEXT],
            ['MÃ BIẾN', 'MA_BIEN', TEXT],
            ['HIỆU LỰC TỪ', 'HIEU_LUC_TU', DATE],
            ['HIỆU LỰC ĐẾN', 'HIEU_LUC_DEN', DATE],
            ['CÔNG THỨC', 'CONG_THUC', TEXT],
            ['GHI CHÚ', 'GHI_CHU', TEXT],
            ['NGƯỜI TẠO', 'NGUOI_TAO', TEXT],
            ['NGÀY CẬP NHẬT', 'UPDATED_AT', DATETIME],
        ],
    },
    templates: {
        table: 'MAU_CONG_LUONG',
        key: 'MA_MAU',
        columns: [
            ['MÃ MẪU', 'MA_MAU', TEXT],
            ['TÊN MẪU', 'TEN_MAU', TEXT],
            ['MÔ TẢ', 'MO_TA', TEXT],
            ['HOẠT ĐỘNG', 'HOAT_DONG', BOOL],
            ['DS TỔ', 'TO_LIST', JSON_LIST],
            ['DS NHÂN SỰ', 'NHAN_SU_LIST', JSON_LIST],
            ['DS LOẠI TRỪ', 'NHAN_SU_LOAI_TRU', JSON_LIST],
            ['PHIÊN BẢN', 'PHIEN_BAN', NUMBER],
            ['KHÓA THAY ĐỔI', 'KHOA_THAY_DOI', BOOL],
            ['NGƯỜI TẠO', 'NGUOI_TAO', TEXT],
        ],
    },
    templateColumns: {
        table: 'CT_MAU_CONG_LUONG',
        key: 'ID',
        columns: [
            ['ID', 'ID', TEXT],
            ['MÃ MẪU', 'MAU_ID', TEXT],
            ['MÃ BIẾN', 'BIEN_ID', TEXT],
            ['CÔNG THỨC', 'CONG_THUC', TEXT],
            ['THỨ TỰ', 'THU_TU', NUMBER],
            ['BẮT BUỘC', 'BAT_BUOC', BOOL],
            ['HIỂN THỊ', 'HIEN_THI', BOOL],
            ['CHO PHÉP NHẬP', 'CHO_PHEP_NHAP', BOOL],
        ],
    },
    agreements: {
        table: 'THOA_THUAN_CONG_LUONG',
        key: 'ID',
        columns: [
            ['ID', 'ID', TEXT],
            ['SỐ HĐ', 'NHAN_SU_ID', TEXT],
            ['MÃ MẪU', 'MAU_ID', TEXT],
            ['HIỆU LỰC TỪ', 'HIEU_LUC_TU', DATE],
            ['HIỆU LỰC ĐẾN', 'HIEU_LUC_DEN', DATE],
            ['GIÁ TRỊ', 'GIA_TRI', JSON_OBJECT],
            ['GHI CHÚ', 'GHI_CHU', TEXT],
            ['NGƯỜI TẠO', 'NGUOI_TAO', TEXT],
        ],
    },
    periods: {
        table: 'BANG_CONG_LUONG',
        key: 'MA_KY',
        columns: [
            ['MÃ KỲ', 'MA_KY', TEXT],
            ['THÁNG', 'THANG', NUMBER],
            ['NĂM', 'NAM', NUMBER],
            ['TỪ NGÀY', 'TU_NGAY', DATE],
            ['ĐẾN NGÀY', 'DEN_NGAY', DATE],
            ['TRẠNG THÁI', 'TRANG_THAI', TEXT],
            ['DS MẪU', 'MAU_IDS', JSON_LIST],
            ['NGƯỜI TẠO', 'NGUOI_TAO', TEXT],
            ['NGƯỜI GỬI', 'NGUOI_GUI', TEXT],
            ['NGÀY GỬI', 'NGAY_GUI', DATETIME],
            ['NGƯỜI DUYỆT', 'NGUOI_DUYET', TEXT],
            ['NGÀY DUYỆT', 'NGAY_DUYET', DATETIME],
            ['NGƯỜI MỞ LẠI', 'NGUOI_MO_LAI', TEXT],
            ['NGÀY MỞ LẠI', 'NGAY_MO_LAI', DATETIME],
            ['LÝ DO TỪ CHỐI', 'LY_DO_TU_CHOI', TEXT],
            ['LÝ DO MỞ LẠI', 'LY_DO_MO_LAI', TEXT],
            ['TỔNG LƯƠNG', 'TONG_LUONG', NUMBER],
            ['TỔNG ỨNG', 'TONG_UNG', NUMBER],
            ['TỔNG BH', 'TONG_BHXH', NUMBER],
            ['TỔNG THỰC CHI', 'TONG_THUC_CHI', NUMBER],
            ['NGÀY TÍNH', 'CALCULATED_AT', DATETIME],
            ['INPUT HASH', 'INPUT_HASH', TEXT],
            ['XÁC NHẬN CẢNH BÁO', 'CANH_BAO_XAC_NHAN', BOOL],
            ['GHI CHÚ', 'GHI_CHU', TEXT],
        ],
    },
    periodDetails: {
        table: 'CT_BANG_CONG_LUONG',
        key: 'ID',
        columns: [
            ['ID', 'ID', TEXT],
            ['MÃ KỲ', 'BANG_ID', TEXT],
            ['SỐ HĐ', 'NHAN_SU_ID', TEXT],
            ['HỌ TÊN', 'HO_TEN_SNAPSHOT', TEXT],
            ['TỔ', 'TO_SNAPSHOT', TEXT],
            ['MÃ MẪU', 'MAU_ID', TEXT],
            ['GIÁ TRỊ NHẬP', 'GIA_TRI_NHAP', JSON_OBJECT],
            ['GIÁ TRỊ TÍNH', 'GIA_TRI_TINH', JSON_OBJECT],
            ['GHI ĐÈ', 'GHI_DE', JSON_OBJECT],
            ['CHI TIẾT NĂNG SUẤT', 'CHI_TIET_NANG_SUAT', JSON_ROWS],
            ['TỔNG LƯƠNG', 'TONG_LUONG', NUMBER],
            ['ỨNG', 'TONG_UNG', NUMBER],
            ['BH NLĐ', 'BH_NLD', NUMBER],
            ['TNCN', 'TNCN', NUMBER],
            ['THỰC CHI', 'TONG_THUC_CHI', NUMBER],
            ['GHI CHÚ', 'GHI_CHU', TEXT],
        ],
    },
    advances: {
        table: 'PHIEU_UNG_LUONG',
        key: 'MA_PHIEU',
        columns: [
            ['MÃ PHIẾU', 'MA_PHIEU', TEXT],
            ['SỐ HĐ', 'NHAN_SU_ID', TEXT],
            ['NGÀY ỨNG', 'NGAY_UNG', DATE],
            ['SỐ TIỀN', 'SO_TIEN', NUMBER],
            ['GHI CHÚ', 'GHI_CHU', TEXT],
            ['TRẠNG THÁI', 'TRANG_THAI', TEXT],
            ['MÃ KỲ', 'BANG_CONG_LUONG_ID', TEXT],
            ['SỐ TIỀN CHỐT', 'SO_TIEN_SNAPSHOT', NUMBER],
            ['NGƯỜI TẠO', 'NGUOI_TAO', TEXT],
        ],
    },
    auditLog: {
        table: 'NHAT_KY_CONG_LUONG',
        key: 'ID',
        columns: [
            ['ID', 'ID', TEXT],
            ['THỜI GIAN', 'THOI_GIAN', DATETIME],
            ['NGƯỜI', 'NGUOI', TEXT],
            ['HÀNH ĐỘNG', 'HANH_DONG', TEXT],
            ['MÃ KỲ', 'MA_KY', TEXT],
            ['CHI TIẾT', 'CHI_TIET', TEXT],
        ],
    },
    // Giai đoạn 6: lịch ngày lễ, sổ phép năm, đơn nghỉ phép (chi tiết từng ngày lưu JSON trong đơn).
    holidays: {
        table: 'LICH_NGAY_LE',
        key: 'ID',
        columns: [
            ['ID', 'ID', TEXT],
            ['MÃ NGÀY LỄ', 'MA_NGAY_LE', TEXT],
            ['TÊN NGÀY LỄ', 'TEN_NGAY_LE', TEXT],
            ['TỪ NGÀY', 'TU_NGAY', DATE],
            ['ĐẾN NGÀY', 'DEN_NGAY', DATE],
            ['SỐ NGÀY HƯỞNG LƯƠNG', 'SO_NGAY_HUONG_LUONG', NUMBER],
            ['LOẠI NGÀY', 'LOAI_NGAY', TEXT],
            ['PHẠM VI', 'PHAM_VI', TEXT],
            ['TỔ', 'TO', TEXT],
            ['SỐ HĐ', 'NHAN_SU_ID', TEXT],
            ['HIỆU LỰC', 'HIEU_LUC', BOOL],
            ['ĐÃ XÁC NHẬN', 'DA_XAC_NHAN', BOOL],
            ['NGƯỜI XÁC NHẬN', 'NGUOI_XAC_NHAN', TEXT],
            ['NGÀY XÁC NHẬN', 'NGAY_XAC_NHAN', DATETIME],
            ['MÔ TẢ', 'MO_TA', TEXT],
            ['NGUỒN', 'NGUON', TEXT],
            ['NGƯỜI TẠO', 'NGUOI_TAO', TEXT],
        ],
    },
    leaveBalances: {
        table: 'PHEP_NAM',
        key: 'ID',
        columns: [
            ['ID', 'ID', TEXT],
            ['SỐ HĐ', 'NHAN_SU_ID', TEXT],
            ['NĂM', 'NAM', NUMBER],
            ['PHÉP CHUẨN', 'PHEP_CHUAN', NUMBER],
            ['PHÉP TỒN NĂM TRƯỚC', 'PHEP_TON_NAM_TRUOC', NUMBER],
            ['PHÉP ĐIỀU CHỈNH', 'PHEP_DIEU_CHINH', NUMBER],
            ['GHI CHÚ', 'GHI_CHU', TEXT],
            ['NGÀY CẬP NHẬT', 'UPDATED_AT', DATETIME],
        ],
    },
    leaveRequests: {
        table: 'DON_PHEP',
        key: 'MA_DON',
        columns: [
            ['MÃ ĐƠN', 'MA_DON', TEXT],
            ['SỐ HĐ', 'NHAN_SU_ID', TEXT],
            ['NĂM', 'NAM', NUMBER],
            ['LOẠI PHÉP', 'LOAI_PHEP', TEXT],
            ['TỪ NGÀY', 'TU_NGAY', DATE],
            ['ĐẾN NGÀY', 'DEN_NGAY', DATE],
            ['SỐ NGÀY', 'SO_NGAY', NUMBER],
            ['CHI TIẾT NGÀY', 'CHI_TIET_NGAY', JSON_ROWS],
            ['LÝ DO', 'LY_DO', TEXT],
            ['TRẠNG THÁI', 'TRANG_THAI', TEXT],
            ['NGƯỜI TẠO', 'NGUOI_TAO', TEXT],
            ['NGÀY TẠO', 'NGAY_TAO', DATETIME],
            ['NGƯỜI DUYỆT', 'NGUOI_DUYET', TEXT],
            ['NGÀY DUYỆT', 'NGAY_DUYET', DATETIME],
            ['LÝ DO TỪ CHỐI', 'LY_DO_TU_CHOI', TEXT],
        ],
    },
    // Bảng có sẵn, module lương chỉ đọc các cột cần dùng.
    employees: {
        table: 'NHANSU',
        key: 'SO_HD',
        columns: [
            ['SỐ HĐ', 'SO_HD', TEXT],
            ['HỌ VÀ TÊN', 'HO_TEN', TEXT],
            ['TỔ', 'TO', TEXT],
            ['BỘ PHẬN', 'BO_PHAN', TEXT],
            ['TRẠNG THÁI LÀM VIỆC', 'TRANG_THAI_LAM_VIEC', TEXT],
            ['NGÀY BẮT ĐẦU', 'NGAY_BAT_DAU', DATE],
            ['NGÀY NGHỈ', 'NGAY_NGHI', DATE],
        ],
    },
    allocations: {
        table: 'TO_PBNS',
        key: 'ID',
        columns: [
            ['ID TỔ CÔNG ĐOẠN', 'ID', TEXT],
            ['TỔ', 'TO', TEXT],
            ['MÃ CÔNG ĐOẠN', 'MA_CONG_DOAN', TEXT],
            ['TÊN CÔNG ĐOẠN', 'TEN_CONG_DOAN', TEXT],
            ['NHÂN SỰ PHỤ TRÁCH', 'NHAN_SU_PHU_TRACH', TEXT],
            ['SỐ HĐ PHỤ TRÁCH', 'SO_HD_PHU_TRACH', TEXT],
            ['HIỆU LỰC TỪ', 'HIEU_LUC_TU', DATE],
            ['HIỆU LỰC ĐẾN', 'HIEU_LUC_DEN', DATE],
            ['NHÓM', 'NHOM', TEXT],
        ],
    },
};

function readCell(raw, type, fallbackList) {
    switch (type) {
        case NUMBER: {
            const value = parseSheetNumber(raw, null);
            return Number.isNaN(value) ? { invalid: true, value: null } : { value };
        }
        case DATE:
        case DATETIME: {
            if (raw === null || raw === undefined || String(raw).trim() === '') return { value: null };
            const value = parseSheetDate(raw);
            return value ? { value } : { invalid: true, value: null };
        }
        case BOOL: return { value: parseSheetBoolean(raw) };
        case JSON_OBJECT: {
            const value = parseSheetJson(raw, undefined);
            if (value === undefined && raw && String(raw).trim()) return { invalid: true, value: {} };
            return { value: value && typeof value === 'object' && !Array.isArray(value) ? value : {} };
        }
        case JSON_LIST: {
            const value = parseSheetJson(raw, undefined);
            if (value === undefined && raw && String(raw).trim()) return { invalid: true, value: fallbackList };
            return { value: Array.isArray(value) ? value.map(String) : fallbackList };
        }
        case JSON_ROWS: {
            const value = parseSheetJson(raw, undefined);
            const valid = Array.isArray(value) && value.every((item) => item && typeof item === 'object' && !Array.isArray(item));
            if (raw && String(raw).trim() && !valid) return { invalid: true, value: [] };
            return { value: valid ? value : [] };
        }
        default: return { value: raw === null || raw === undefined ? '' : String(raw).trim() };
    }
}

function writeCell(value, type) {
    switch (type) {
        case NUMBER: return value === null || value === undefined || value === '' ? '' : Number(value);
        case DATE: return value ? toSheetDate(value) : '';
        case DATETIME: return value ? toSheetDateTime(value) : '';
        case BOOL: return Boolean(value);
        case JSON_OBJECT: return toSheetJson(value ?? {});
        case JSON_LIST:
        case JSON_ROWS: return toSheetJson(value ?? []);
        default: return value === null || value === undefined ? '' : String(value);
    }
}

/**
 * Đọc một dòng sheet. Ô không đọc được (số mà thành ngày, ngày sai dạng, JSON hỏng) không bị lặng lẽ
 * coi là 0: giá trị để null và tên cột được ghi vào _issues để màn hình cảnh báo.
 */
export function fromSheetRow(schema, row) {
    const result = { _issues: [] };
    for (const [column, field, type] of schema.columns) {
        const { value, invalid } = readCell(row?.[column], type, []);
        result[field] = value;
        if (invalid) result._issues.push({ table: schema.table, column, value: row?.[column] });
    }
    return result;
}

// Chỉ ghi các trường có trong object, để Edit một phần không xóa mất cột khác.
export function toSheetRow(schema, object) {
    const row = {};
    for (const [column, field, type] of schema.columns) {
        if (Object.prototype.hasOwnProperty.call(object, field)) row[column] = writeCell(object[field], type);
    }
    return row;
}

function keyColumnOf(schema) {
    return schema.columns.find(([, field]) => field === schema.key)[0];
}

function columnOf(schema, field) {
    const column = schema.columns.find(([, name]) => name === field);
    if (!column) throw new Error(`Bảng ${schema.table} không có trường ${field}`);
    return column[0];
}

/** Đọc/ghi một bảng theo khai báo. Dòng trả về đã bỏ trùng khóa và đổi sang tên trường của code. */
export function createTableRepo(schema) {
    const keyColumn = keyColumnOf(schema);
    return {
        schema,
        async list(selector) {
            const rows = await findRows(schema.table, selector, keyColumn);
            return rows.map((row) => fromSheetRow(schema, row));
        },
        async listWhere(field, value) {
            return this.list(equalsSelector(schema.table, columnOf(schema, field), value));
        },
        async add(objects, onProgress) {
            await writeRows(schema.table, 'Add', objects.map((object) => toSheetRow(schema, object)), onProgress);
        },
        async update(objects, onProgress) {
            await writeRows(schema.table, 'Edit', objects.map((object) => toSheetRow(schema, object)), onProgress);
        },
        async remove(keys, onProgress) {
            await writeRows(schema.table, 'Delete', keys.map((key) => ({ [keyColumn]: key })), onProgress);
        },
    };
}

export const payrollRepos = Object.fromEntries(
    Object.entries(PAYROLL_TABLES).map(([name, schema]) => [name, createTableRepo(schema)]),
);
